<template>
  <div>
    <loading :status="loading" />
    <div v-if="!loading">
      <div class="space-x-2 flex justify-between">
        <qr-code v-if="repair.qr_link" :size="Number(app.printer.qr_code_size)" :color="app.printer.font_color" :text="`${repair.qr_link}`"></qr-code>
        <h2 class="w-full font-bold tracking-wider uppercase">
          <strong class="text-2xl">{{ app.name }}</strong>
          <small>
            <p v-if="app.phone">{{ app.phone }}</p>
            <p v-html="app.address"></p>
          </small>
        </h2>
      </div>
      <div class="flex items-center mt-2">
        <label class="min-w-32 block font-bold uppercase">{{ $t('Repair Invoice date') }}</label>
        <span class="mr-4 inline-block">:</span>
        <div>{{ repair.created_at }}</div>
      </div>
      <div class="flex items-center">
        <label class="min-w-32 block font-bold uppercase">{{ $t('Repair Invoice ID') }}</label>
        <span class="mr-4 inline-block">:</span>
        #{{ repair.tracking }} [ {{ repair.id }} ]
      </div>
      <div class="flex items-center">
        <label class="min-w-32 block font-bold uppercase">{{ $t('Tax Identity') }} ({{ $t('VAT') }})</label>
        <span class="mr-4 inline-block">:</span>
        {{ repair.tax.tax_id }}
      </div>
      <div class="w-full mb-1 mt-1 py-1 overflow-hidden">
        <div>
          <div class="flex items-center">
            <label class="min-w-32 block font-bold uppercase">{{ $t('Customer name') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ repair.name | capitalize }}</div>
          </div>
          <div v-if="repair.email" class="flex items-center">
            <label class="min-w-32 block font-bold uppercase">{{ $t('Customer email') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ repair.email | capitalize }}</div>
          </div>
          <div v-if="repair.phone" class="flex items-center">
            <label class="min-w-32 block font-bold uppercase">{{ $t('Customer phone') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ repair.phone | capitalize }}</div>
          </div>
          <div v-if="repair.address" class="flex items-center">
            <label class="min-w-32 block font-bold uppercase">{{ $t('Customer address') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ repair.address | capitalize }}</div>
          </div>
        </div>
      </div>
      <div class="w-full mb-1 mt-1 py-1 overflow-hidden">
        <div>
          <div class="flex items-center">
            <label class="min-w-32 block font-bold uppercase">{{ $t('Device') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ repair.device_name }}</div>
          </div>
          <div class="flex items-center">
            <label class="min-w-32 block font-bold uppercase">{{ $t('IMEI') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ repair.imei }}</div>
          </div>
          <div class="flex items-center">
            <label class="min-w-32 block font-bold uppercase">{{ $t('Serial number') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ repair.serial_number }}</div>
          </div>
          <div class="flex items-center">
            <label class="min-w-32 block font-bold uppercase">{{ $t('Issue') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ repair.issue }}</div>
          </div>
        </div>
      </div>
      <div class="w-full mb-1 mt-1 py-1 overflow-hidden">
        <div class="flex justify-between font-semibold">
          <p>{{ $t('Charges') }} :</p>
          <p class="pl-2">{{ repair.charges | currency }}</p>
        </div>
        <div class="flex justify-between font-semibold">
          <template v-if="repair.tax.is_tax_fix">
            <p>{{ $t('Tax') }} ({{ repair.tax.rate }} {{ $t('fix') }}) :</p>
          </template>
          <template v-else>
            <p>{{ $t('Tax') }} ({{ repair.tax.rate }}%) :</p>
          </template>
          <p class="pl-2">{{ repair.tax_amount | currency }}</p>
        </div>
        <div class="flex justify-between font-semibold">
          <p>{{ $t('Total') }} :</p>
          <p class="pl-2">{{ repair.total_amount | currency }}</p>
        </div>
      </div>
      <div class="py-1 overflow-hidden">
        <div class="px-1 flex justify-between font-semibold">
          <p>{{ $t('Prepaid') }}:</p>
          <p class="pl-2">{{ repair.prepaid | currency }}</p>
        </div>
        <div class="px-1 flex justify-between font-semibold">
          <p>{{ $t('Due') }} :</p>
          <p class="pl-2">{{ repair.due | currency }}</p>
        </div>
      </div>
      <div class="pt-2">
        <template v-if="app.terms.repairs">
          <div class="font-bold text-left">
            {{ $t('I acknowledge the following terms and conditions') }}
          </div>
          <div class="terms px-5">
            <p v-html="app.terms.repairs"></p>
          </div>
        </template>
        <div class="flex justify-between">
          <div class="font-bold flex-1">
            {{ $t('Signature') }}
          </div>
          <div class="font-sm">------------------------------</div>
        </div>
      </div>
      <div class="flex place-content-center">
        <barcode width="1" :lineColor="app.printer.font_color" :value="repair.tracking" class="self-center" height="25" />
      </div>
    </div>
  </div>
</template>
<script>
import VueBarcode from 'vue-barcode';
import VueQRCodeComponent from 'vue-qrcode-component';

export default {
  name: 'sale-order',
  metaInfo() {
    return {
      title: this.$i18n.t('Print sale order'),
    };
  },
  components: {
    'qr-code': VueQRCodeComponent,
    barcode: VueBarcode,
  },
  computed: {
    app() {
      return this.$store.getters['app/getSettings'];
    },
  },
  data() {
    return {
      loading: false,
      repair: {
        qr_link: null,
        tax: {
          rate: 0,
          tax_id: null,
          is_tax_included: false,
          is_tax_fix: false,
        },
      },
    };
  },
  mounted() {
    this.getRepairOrder();
  },
  methods: {
    getRepairOrder() {
      this.loading = true;
      axios
        .get(route('print-repair-order', this.$route.params.uuid))
        .then((response) => {
          this.repair = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
